module.exports = __webpack_public_path__ + "img/cs2.e41bdf2e.png";